<template>
    <div :class="[
        'expandable',
        'panel',
        { 'is-open': isOpen }
    ]">
        <div class="expandable-container">
            <div class="expandable-label">
                <span 
                    v-bastards
                    class="text-bold fs-18"
                >
                    {{ label }}
                </span>
            </div>
            <div class="expandable-intro">
                <span 
                    v-bastards
                    class="fs-14"
                >
                    {{ introText }}
                </span>
            </div>
            <div 
                class="expandable-body fs-14"
                @click="isOpen = false"
            >
                <slot />
            </div>
            <a
                class="expandable-link link-underline-in fs-14 text-bold"
                v-text="'przeczytaj całość'"
                @click="isOpen = true"
            />
        </div>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'

export default {
    props: {
        label: {
            type: String,
            required: true
        },
        introText: {
            type: String,
            required: true
        }
    },

    data () {
        return {
            isOpen: false
        }
    },

    watch: {
        isOpen(value) {
            if (value === true) {
                VueScrollTo.scrollTo('.expandable', 800)
            }
        }
    }
}
</script>

<style lang="scss">
.expandable {
    margin: 17px 0;
    min-height: 70px;

    &-container {
        position: relative;
        height: 100%;
        padding: 22px 60px 0 210px;
    }

    &-label {
        position: absolute;
        left: 52px;
    }

    &-intro {
        padding: 3px 300px 0 0;
    }

    &-body {
        cursor: pointer;
        max-height: 0;
        opacity: 0;
    }

    &-link {
        cursor: pointer;
        right: 115px;
        top: 25px;

        &:after {
            content: "\e901";
            @include size(20px);
            @include border-circle();
            color: #f4f4f4;
            border: 1px solid #f4f4f4;
            font-family: 'noun_icon';
            text-align: center;
            position: absolute;
            top: calc(50% - 12px);
            right: -31px;
            top: 1px;
            font-size: 14px;
            line-height: 22px;
        }

        &.link-underline-in {
            position: absolute;
        }
    }

    &-intro,
    &-link {
        @include transition(opacity .100s, visibility .100s, max-height .100s);
    }

    &-body {
        @include transition(opacity .500s, visibility .500s, max-height .500s);
        overflow: hidden;
    }

    &.is-open & {
        &-intro {
            @include hide();
            max-height: 0;
        }

        &-body {
            max-height: none;
            max-height: unset;
            padding-bottom: 25px;
            opacity: 1;
        }

        &-link {
            @include hide();
        }
    }

    @media (max-width: $screen-laptop) {
        &-container {
            padding: 22px 60px 25px 160px;
        }

        &-label {
            left: 25px;
        }

        &-intro {
            padding-right: 135px;
            padding-top: 3px;
        }

        &-link {
            right: 55px;
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        &-container {
            padding: 60px 20px 25px 20px;
        }

        &-label {
            top: 22px;
            left: 20px;
        }

        &-intro {
            padding: 0;
        }
    }
}
</style>